import moment from "moment"

export const getPartOfDay = () => { 
    const currentTime = moment().local().format("LT")
    switch(true){
        case currentTime.includes("AM"):
            return {label: "morning", icon: '/sun-symbol.png'};
        case currentTime.includes("PM") && Number(currentTime.split(":")[0]) >= 6:
            return {label: "evening", icon: '/crescent-moon.png'};
        case currentTime.includes("PM") && Number(currentTime.split(":")[0]) < 6:
            return {label: "afternoon", icon: '/sun-symbol.png'};
    }
}

export const  getDate = () => {
    return moment.utc().toISOString();
}